// utils/rateLimiter.ts
const rateLimiter = new Map<string, { count: number; resetTime: number }>();

export function checkRateLimit(identifier: string, maxRequests: number = 10, windowMs: number = 60000): void {
  const now = Date.now();
  const current = rateLimiter.get(identifier);
  
  if (!current || now > current.resetTime) {
    rateLimiter.set(identifier, { count: 1, resetTime: now + windowMs });
    return;
  }
  
  if (current.count >= maxRequests) {
    throw new Error('Rate limit exceeded. Please try again later.');
  }
  
  current.count++;
}